module.exports = __webpack_public_path__ + "img/IMG_9701_L_Black_MockedUp.d3e40ac2.jpg";